<template>
  <div class="item-receipt-modal-bg" v-if="board.itemReceipt.show">
    <form @keyup.esc="close()" tabindex="0" >
      <v-layout id='item_receipt_modal' class='item-receipt-modal' v-resize="onResize" :style="{'left': left, 'top': top}">
        <div class="receipt-view-wrap">
          <v-flex shrink>
            <div class="view-title-bar">
              <v-layout class="column" fill-height>
                <v-flex glow>
                  <v-layout align-center justify-space-between row fill-height>
                    <!-- 좌측 -->
                    <v-flex class="title-bar-item shrink">
                      <v-btn fit icon class="hidden-md-and-up" @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
                    </v-flex>
                    <v-flex class="title-bar-item text-xs-center shrink">
                      {{getStep()}}%
                    </v-flex>
                    <v-flex class="title-bar-item shrink">
                      <v-btn fit icon class="hidden-sm-and-down" @click="close()"><v-icon>close</v-icon></v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink>
                  <v-progress-linear
                    :value="getStep()"
                    height="5"
                    class="receipt-modal-progress"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <div class="view-detail">
            <!-- 1step 주소지 -->
            <div v-if="step === 1">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">방 내 놓으시려구요?<br>주소지를 입력해주세요.</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-text-field
                      v-if="!postShow || form.notFoundAddr"
                      v-model="form.roadAddr"
                      :label="`${((form.notFoundAddr) ? '주소지를 직접 입력해주세요.' : '주소지를 입력해주세요.')}`"
                      :rules="rules.addr"
                      :readonly="!form.notFoundAddr"
                      @click="addrClick()"
                    ></v-text-field>
                    <div v-if="postShow && !form.notFoundAddr">
                      <VueDaumPostcode @complete="postComplete($event)"/>
                    </div>
                    <v-checkbox
                      v-model="form.notFoundAddr"
                      label="주소지가 검색되지 않는다면 체크해주세요!"
                      color="error"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-text-field
                      v-model="form.addr2"
                      label="상세 주소를 입력해주세요."
                      :rules="rules.addr2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="form-item" v-show="minimapShow">
                    <MiniMap5 ref="postcodemap"
                              :appKey="map.appKey"

                              :center="map.center"
                              :level="map.level"
                              :mapTypeId.sync="map.mapTypeId"
                              :libraries="map.libraries"

                              @load="onLoad"
                              @zoom_start="onMapEvent('zoom_start', $event)"
                              @zoom_changed="onMapEvent('zoom_changed', $event)"
                              @click="onMapEvent('click', $event)"
                              @dblclick="onMapEvent('dblclick', $event)"
                              @rightclick="onMapEvent('rightclick', $event)"
                              @dragstart="onMapEvent('dragstart', $event)"
                              @dragend="onMapEvent('dragend', $event)"
                              @idle="onMapEvent('idle', $event)"
                              @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                              style="position:relative; width:100%; height: 230px;">
                    </MiniMap5>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <!-- 2step 방의 구조 -->
            <div v-if="step === 2">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">어떤 구조의 방인가요?</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-radio-group v-model="form.roomType" class="radio-group">
                      <v-radio color="primary" label="원룸" value="1"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="투룸" value="2"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="쓰리룸+" value="3"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="오피스텔" value="4"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="1.5룸" value="5"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="복층" value="6"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <!-- 3step 얼마에? -->
            <div v-if="step === 3">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">어떤 유형으로,<br>얼마에 내 놓으시겠어요?</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-checkbox label="월세" v-model="form.saleType1" hide-details class="shrink my-2" color="primary"></v-checkbox>
                    <v-flex class="mt-3" v-if="form.saleType1">
                      <v-text-field
                        v-model="form.saleType1Price"
                        :rules="rules.saleType1Price"
                        label="보증금"></v-text-field>
                      <v-text-field
                        v-model="form.saleType1MonthlyPrice"
                        :rules="rules.saleType1MonthlyPrice"
                        label="월세"></v-text-field>
                      <v-text-field
                        v-model="form.saleType1MCost"
                        :rules="rules.saleType1MCost"
                        label="관리비"></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-checkbox label="전세" v-model="form.saleType2" hide-details class="shrink my-2" color="primary"></v-checkbox>
                    <v-flex class="mt-3" v-if="form.saleType2">
                      <v-text-field
                        v-model="form.saleType2Price"
                        :rules="rules.saleType2Price"
                        label="전세"></v-text-field>
                      <v-text-field
                        v-model="form.saleType2MCost"
                        :rules="rules.saleType2MCost"
                        label="관리비"></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-checkbox label="매매" v-model="form.saleType3" hide-details class="shrink my-2" color="primary"></v-checkbox>
                    <v-flex class="mt-3" v-if="form.saleType3">
                      <v-text-field
                        v-model="form.saleType3Price"
                        :rules="rules.saleType3Price"
                        label="매매가"></v-text-field>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <!-- 4step 기타 상세내용 -->
            <div v-if="step === 4">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">기타 상세내용을 입력해주세요.</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-text-field
                      v-model="form.buildingName"
                      label="건물명을 입력해주세요. (없을시 공백)"></v-text-field>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-text-field
                      v-model="form.roomName"
                      :rules="rules.roomName"
                      label="방의 호수를 입력해주세요."></v-text-field>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-radio-group v-model="form.dateType" class="radio-group">
                      <v-radio color="primary" label="현재공실" value="1"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="날짜선택" value="2"></v-radio>
                      <div v-if="form.dateType === '2'">
                        <v-text-field
                          v-model="form.dateMemo"
                          :rules="rules.dateMemo"
                          label="공실 예정일을 입력해주세요."></v-text-field>
                      </div>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="날짜협의" value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <!-- 5step 사진 -->
            <div v-if="step === 5">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">방의 사진을 첨부 하시겠습니까?</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-radio-group v-model="form.photoType" class="radio-group">
                      <v-radio color="primary" label="사진을 첨부하지 않겠습니다." value="1"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="사진을 첨부하겠습니다." value="2"></v-radio>
                      <!-- 파일 첨부영역 -->
                      <div v-show="form.photoType == 2" class="photo-upload">
                        <v-layout class="upload-dropbox justify-space-between align-center">
                          <v-flex class="text-info">
                            첨부할 파일을 이곳으로 드래그 하거나,<br>
                            해당 영역을 클릭하여 파일을 선택해주세요.
                          </v-flex>
                          <input class="upload-input glow" name="upload-input" type="file" @change="filesChange($event.target.name, $event.target.files)" accept="image/*" multiple/>
                        </v-layout>
                        <v-layout class="photo-files column">
                          <v-flex v-for="(file, index) in photoFiles" :key="index" class="photo-files-item">
                            <v-btn flat icon color="pink" size="11" @click="removeFile(index)">
                              <v-icon>close</v-icon>
                            </v-btn>
                            <span>{{ file.name }}</span>
                          </v-flex>
                        </v-layout>
                      </div>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="촬영을 요청합니다." value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <!-- 6step 문의자 정보 -->
            <div v-if="step === 6">
              <div class="title-area">
                <div class="bg-img">
                  <img :src="`${$utile.getStaticUrl()}/receipt-bg.jpg`" >
                  <v-layout align-center justify-center class="bg-cover">
                    <div class="title-text">문의하시는 분의 정보와<br>남기실 말씀을 입력해주세요.</div>
                  </v-layout>
                </div>
              </div>
              <div class="form-area">
                <v-layout class="column form-box">
                  <v-flex class="form-item">
                    <v-radio-group v-model="form.owner" class="radio-group">
                      <v-radio color="primary" label="임대인(집주인)" value="1"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="임차인(세입자)" value="2"></v-radio>
                      <v-flex class="line"></v-flex>
                      <v-radio color="primary" label="기타" value="3"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-text-field
                      v-model="form.ownerTel"
                      :rules="rules.ownerTel"
                      label="연락처를 입력해주세요."></v-text-field>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-textarea
                      v-model="form.ownerMemo"
                      label="남기실 말씀을 입력해주세요."
                      hint="최대 255자까지 입력이 가능합니다."
                      counter="255"
                    ></v-textarea>
                  </v-flex>
                  <v-flex class="form-item">
                    <v-checkbox
                      v-model="form.approval"
                      :rules="[v => !!v || '']"
                      label=""
                      color="title_color"
                    >
                      <template slot="append"><span style="color: rgba(0,0,0,.54) !important; white-space: nowrap; line-height: 1; padding-top:3px;"><a href="/bbs/content.php?co_id=privacy" target="_blank" style="line-height: 1;">개인정보처리방침</a>, <a href="/bbs/content.php?co_id=provision" target="_blank">이용약관</a> 동의</span></template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>
          <!-- 하단 바 -->
          <v-flex shrink>
            <div class="view-bottom-bar">
              <v-layout class="bar-wrap" justify-center fill-height>
                <v-flex class="item prev" v-if="step > 1" @click="prevPage()"><span>이전</span></v-flex> <!-- /*border-right:solid 1px #69a6ff;*/ -->
                <v-flex :class="`item ${(isPass? '' : 'disable')}`"  @click="nextPage()">
                  <v-progress-circular
                    indeterminate
                    :size="25"
                    :width="3"
                    color="primary"
                    v-if="submitLoading"
                  ></v-progress-circular>
                  <span v-if="!submitLoading">{{(step === maxStep)? '방내놓기' : '다음'}}</span>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </div>
      </v-layout>
    </form>
  </div>
</template>

<script>
// import Config from '@/config'
import { mapState, mapActions } from 'vuex'
import EventBus from '@/utile/eventBus'
import { VueDaumPostcode } from 'vue-daum-postcode'
import MiniMap5 from '@/components/plugin/KakaoMap'
import axios from 'axios'
// import qs from 'qs'

export default {
  name: 'ItemReceipt',
  data: () => ({
    postShow: false,
    minimapShow: false,
    submitLoading: false,
    left: 0,
    top: 0,
    step: 1,
    maxStep: 6,
    form: {
      // 1 step
      roadAddr: '',
      jibunAddr: '',
      notFoundAddr: false,
      addr2: '', // 상세주소
      bcode: '', // 법정동코드
      // 2 step
      roomType: 0, // 1 원룸, 2 투룸, 3 쓰리룸+, 4오피스텔, 1.5룸, 복층
      saleType1: false, // 월세
      saleType1Price: '', // 월세 보증금 가격
      saleType1MonthlyPrice: '', // 월세 가격
      saleType1MCost: '', // 월세 관리비
      saleType2: false, // 전세
      saleType2Price: '', // 전세 가격
      saleType2MCost: '', // 전세 관리비
      saleType3: false, // 매매
      saleType3Price: '', // 매매 가격
      // 3 step
      buildingName: '',
      roomName: '',
      dateType: 0,
      dateMemo: '',
      // 4 step
      photoType: 0,
      // 5 step
      owner: 0,
      ownerTel: '',
      ownerMemo: '',
      approval: false
    },
    photoFiles: [],
    rules: {
      addr: [
        v => !!v || '주소지를 입력해주세요.'
      ],
      addr2: [
        v => !!v || '상세주소를 입력해주세요.'
      ],
      //
      saleType1Price: [
        v => !!v || '보증금을 입력해주세요.'
      ],
      saleType1MonthlyPrice: [
        v => !!v || '월세를 입력해주세요.'
      ],
      saleType1MCost: [
        v => !!v || '관리비를 입력해주세요.'
      ],
      saleType2Price: [
        v => !!v || '전세가를 입력해주세요.'
      ],
      saleType2MCost: [
        v => !!v || '관리비를 입력해주세요.'
      ],
      saleType3Price: [
        v => !!v || '매매가를 입력해주세요.'
      ],
      //
      dateMemo: [
        v => !!v || '공실 예정일을 입력해주세요.'
      ],
      roomName: [
        v => !!v || '방의 호수를 입력해주세요.'
      ],
      //
      ownerTel: [
        v => !!v || '연락처를 입력해주세요.'
      ]
    },
    map: {
      appKey: '',
      center: { lat: 37.4803073, lng: 126.9328443 },
      level: 3, // 기본 3
      mapTypeId: MiniMap5.MapTypeId.NORMAL,
      libraries: [ 'services' ],
      mapObject: null,
      roadviewArea: false,
      polygon: null
    }
  }),
  created () {
    this.map.appKey = this.config.kakaRestApiAppKey
  },
  mounted () {
    // 창이 닫히는지 확인
    this.$store.watch(() => this.board.itemReceipt.show, (newValue, oldValue) => {
      if (!newValue) {
        this.$router.replace('map')
      } else {
        this.$refs.postcodemap.init()
      }
    })
  },
  components: {
    VueDaumPostcode,
    MiniMap5
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    }),
    isPass: function () {
      if (this.submitLoading) {
        return false
      }
      if (this.step === 1) {
        if (this.form.roadAddr !== '' && this.form.addr2 !== '') {
          return true
        }
      } else if (this.step === 2) {
        if (this.form.roomType !== 0) {
          return true
        }
      } else if (this.step === 3) {
        if (this.form.saleType1 && this.form.saleType1Price !== '' && this.form.saleType1MonthlyPrice !== '' && this.form.saleType1MCost !== '') {
          return true
        }
        if (this.form.saleType2 && this.form.saleType2Price !== '' && this.form.saleType2MCost !== '') {
          return true
        }
        if (this.form.saleType3 && this.form.saleType3Price !== '') {
          return true
        }
      } else if (this.step === 4) {
        if (this.form.roomName !== '' && (this.form.dateType === '1' || this.form.dateType === '3' || (this.form.dateType === '2' && this.form.dateMemo !== ''))) {
          return true
        }
      } else if (this.step === 5) {
        if (this.form.photoType !== 0) {
          return true
        }
      } else if (this.step === 6) {
        if (this.form.owner !== 0 && this.form.ownerTel !== '' && this.form.approval) {
          return true
        }
      } else if (this.step === 7) {
        //
      }
      return false
    }
  },
  methods: {
    ...mapActions({
      requestBoardData: 'board/requestBoardData'
    }),
    // UPLOAD
    filesChange (filename, files) {
      // add all selected files
      let input = this.$el.querySelector('input[name="upload-input"]')
      for (let file of input.files) {
        this.photoFiles.push(file)
      }
      // reset file input
      input.value = null
    },
    removeFile (index) {
      this.photoFiles.splice(index, 1)
    },
    showUpload () {
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': true
      })
      let input = this.$el.querySelector('input[name="upload-input"]')
      input.dispatchEvent(event)
    },
    // FORM
    close () {
      this.board.itemReceipt.show = false
    },
    getStep () {
      return parseInt(this.step * (100 / this.maxStep))
    },
    prevPage () {
      if (this.step > 1) this.step--
      // 맵 재로드
      if (this.step === 1 && this.form.bcode !== '') {
        let _this = this
        setTimeout(function () {
          _this.$refs.postcodemap.init()
        }, 500)
      }
    },
    nextPage () {
      if (this.isPass) {
        if (this.step === this.maxStep) {
          // submit 전송
          this.submitLoading = true
          // FormData 전송 시작
          let frm = new FormData()
          this.photoFiles.forEach(function (item, index, array) {
            frm.append('bf_file[]', item)
          })
          frm.append('form', encodeURI(JSON.stringify(this.form))) // qs.stringify(jsonData)
          axios.post(this.$utile.getRestUrl() + '/rep.board.receipt.api', frm,
            this.$utile.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
          )
            .then((response) => {
              // 응답 처리
              // console.log(response.data.array)
              if (response.data.array.rcode === '1') {
                this.close()
                this.reset()
              }
              EventBus.$emit('alert', response.data.array.msg)
              this.submitLoading = false
            })
            .catch((e) => {
              // 예외 처리
              EventBus.$emit('alert', '방내놓기 요청에 실패하였습니다. 다시 시도 바랍니다.')
              this.submitLoading = false
            })
          //
        } else {
          this.step++
        }
      } else {
        //
      }
    },
    postComplete (event) {
      // console.log(event)
      this.form.jibunAddr = event.jibunAddress
      this.form.roadAddr = event.roadAddress
      this.form.bcode = event.bcode
      //
      this.minimapShow = true
      this.postShow = false
      this.$refs.postcodemap.init()
      //
    },
    addrClick () {
      if (!this.form.notFoundAddr) {
        this.postShow = true
      }
    },
    reset () {
      this.postShow = false
      this.minimapShow = false
      this.submitLoading = false
      this.step = 1
      // 1 step
      this.form.roadAddr = ''
      this.form.jibunAddr = ''
      this.form.notFoundAddr = false
      this.form.addr2 = ''
      this.form.bcode = ''
      // 2 step
      this.form.roomType = 0 // 1 원룸, 2 투룸, 3 쓰리룸+, 4오피스텔, 1.5룸, 복층
      this.form.saleType1 = false // 월세
      this.form.saleType1Price = '' // 월세 보증금 가격
      this.form.saleType1MonthlyPrice = '' // 월세 가격
      this.form.saleType1MCost = '' // 월세 관리비
      this.form.saleType2 = false // 전세
      this.form.saleType2Price = '' // 전세 가격
      this.form.saleType2MCost = '' // 전세 관리비
      this.form.saleType3 = false // 매매
      this.form.saleType3Price = '' // 매매 가격
      // 3 step
      this.form.buildingName = ''
      this.form.roomName = ''
      this.form.dateType = 0 // 1 공실, 2 날짜지정, 3 날짜협의
      this.form.dateMemo = ''
      // 4 step
      this.form.photoType = 0
      // 5 step
      this.form.owner = 0
      this.form.ownerTel = ''
      this.form.ownerMemo = ''
      this.form.approval = false
      this.photoFiles = []
    },
    /* 맵 온로드 */
    onLoad (map) {
      // console.log('맵로드')
      this.map.mapObject = map
      // 초기셋팅
      this.initMap()
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      // console.log(`Daum Map Event(${event})`, params) // 이벤트 로그
    },
    initMap () {
      this.$refs.postcodemap.addressSearch(this.form.jibunAddr)
    },
    onResize () {
      if (document.getElementById('item_receipt_modal') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('item_receipt_modal').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/ItemReceipt.vue